// A panel's one line under its title, and, for a panel that declares
// `sends`, the grants it was drawn for under it — *records go to northwind*,
// *usage goes to northwind* (02-DESIGN/14-solutions/03-the-console.md § the
// elements; hq issue 185).

import type { ReactNode } from "react";

import type { Manifest, Panel } from "../../wire/solutions.ts";
import { forSolution, grantWords, type Grant } from "./sends.ts";

/** panelLine is what the page head shows under a panel's title; undefined where it has nothing to say. */
export function panelLine(m: Manifest, p: Panel, grants: readonly Grant[]): ReactNode {
  const words = grantWords(p.sends, forSolution(grants, m.name));
  if (words.length === 0) {
    return p.line;
  }
  return (
    <>
      {p.line}
      {p.line !== undefined && <br />}
      <span className="small faint">{words.join(" · ")}</span>
    </>
  );
}
